/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Casmanagement_Templates1Inputs */

const en_settings_casmanagement_templates1 = /** @type {(inputs: Settings_Casmanagement_Templates1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template Library`)
};

/**
* | output |
* | --- |
* | "Template Library" |
*
* @param {Settings_Casmanagement_Templates1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_casmanagement_templates1 = /** @type {((inputs?: Settings_Casmanagement_Templates1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Casmanagement_Templates1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_casmanagement_templates1(inputs)
});
export { settings_casmanagement_templates1 as "settings_casManagement_templates" }